import { PHILOSOPHY_CARDS, type PhilosophyCard } from "@/lib/content/philosophy";
import { cn } from "@/lib/utils/cn";

type Props = {
  variant?: "default" | "compact";
  className?: string;
};

export function PhilosophyCards({ variant = "default", className }: Props) {
  return (
    <ul className={cn("space-y-2.5", className)}>
      {PHILOSOPHY_CARDS.map((c) => (
        <CardItem key={c.id} card={c} compact={variant === "compact"} />
      ))}
    </ul>
  );
}

function CardItem({ card, compact }: { card: PhilosophyCard; compact: boolean }) {
  return (
    <li
      className={cn(
        "rounded-[18px] border border-line bg-card shadow-card text-left",
        compact ? "px-3.5 py-3" : "px-4 py-3.5",
      )}
    >
      <span
        className={cn(
          "inline-flex items-center gap-1 rounded-full font-semibold",
          compact ? "px-2 py-0.5 text-[10.5px]" : "px-2.5 py-1 text-[11px]",
          card.pillCls,
        )}
      >
        <span aria-hidden>{card.emoji}</span>
        {card.tag}
      </span>
      <h3
        className={cn(
          "mt-1.5 font-semibold leading-tight",
          compact ? "text-[13.5px]" : "text-[14.5px]",
        )}
      >
        {card.title}
      </h3>
      <p
        className={cn(
          "mt-1 text-muted leading-snug",
          compact ? "text-[12px]" : "text-[12.5px]",
        )}
      >
        {card.body}
      </p>
    </li>
  );
}
